


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect, mdbAlert } from '@folky-tools/mdbvue';
import { Category } from '@/models/references-classification/category';
import { required, maxLength } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbAlert
    },
    validations: {
        category: { name: { required, maxLength: maxLength(32) } }
    }
})
export default class EditCategory extends Vue {
    @Prop(Category) private category!: Category;
    @Prop() private allCategories!: Category[];
    private categoryCopy: Category = new Category();
    private parentCategories: Category[] = [];
    private categoryNameMaxCharLength: number = 32;

    private beforeMount(): void {
        this.categoryCopy = this.category.clone();

        let categoryIdsToExclude: number[] = [];
        if (this.category.id > 0) {
            categoryIdsToExclude = this.getCategoryIdsToExclude(this.category.id);
        }

        const allCategories = categoryIdsToExclude && categoryIdsToExclude.length > 0 ? this.allCategories.filter(c => !categoryIdsToExclude.some(id => id === c.id)) : this.allCategories;
        this.parentCategories = allCategories.map(c => {
            const category = c.clone();

            let space = '';
            for (let i = 0; i < category.level; i++) {
                space += '     ';
            }
            category.name = `${space}${category.name}`;

            if ((category.id < 1 && (this.category.id < 0 || this.category.parentCategoryId === null)) || category.id === this.category.parentCategoryId) {
                category.selected = true;
            }

            return category;
        });
    }

    private getCategoryIdsToExclude(categoryId: number): number[] {
        let result: number[] = [categoryId];

        const childrenCategories = this.allCategories.filter(c => c.parentCategoryId === categoryId);
        if (childrenCategories && childrenCategories.length > 0) {
            childrenCategories.forEach(c => {
                result = [...result, ...this.getCategoryIdsToExclude(c.id)];
            });
        }

        return result;
    }

    private onChangeParentCategory(parentCategoryId: number | null): void {
        this.category.isQuickNavigation = this.categoryCopy.isQuickNavigation;
        this.category.isQuickNavigationInherited = this.categoryCopy.isQuickNavigationInherited;

        if (parentCategoryId) {
            const parentCategory = this.allCategories.find(c => c.id === parentCategoryId);
            this.category.parentCategoryId = parentCategory!.id;
            if (parentCategory!.isQuickNavigation) {
                this.category.isQuickNavigation = true;
                this.category.isQuickNavigationInherited = true;
            } else if (this.category.isQuickNavigation && this.category.isQuickNavigationInherited) {
                this.category.isQuickNavigation = false;
                this.category.isQuickNavigationInherited = false;
            }
        } else {
            this.category.parentCategoryId = null;
        }
    }

    private hasErrors(): boolean {
        this.$v.category.$touch();
        if (this.$v.category.$error) {
            return true;
        }
        return false;
    }
}
